import { ToolkitPropertyTableUI } from '../ToolkitPropertyTable/ToolkitPropertyTableUI.js';
import { VacantLandSalesProperty } from './types.js';
import { useVacantLandSalesTable } from './useVacantLandSalesTable.js';

export const VacantLandSalesTable = ({
  vacantLandSales,
  orderID,
  onRowClick,
  focusedRowIndex,
}: {
  vacantLandSales: VacantLandSalesProperty[];
  orderID: string;
  onRowClick: (row: VacantLandSalesProperty) => void;
  focusedRowIndex: number;
}) => {
  const { table } = useVacantLandSalesTable(vacantLandSales, orderID);

  const handleRowClick = (row: VacantLandSalesProperty) => {
    onRowClick(row);
  };

  return (
    <div className="vacant-land-sales-table-wrapper">
      <ToolkitPropertyTableUI
        table={table}
        shouldPinFirstRow={false}
        onRowClick={handleRowClick}
        activeRowIndex={focusedRowIndex}
      />
    </div>
  );
};
